// Single editable source for the "What you now know" / "Your next steps" section.
export const FEE = "1.25%";

export const JOIN_URL = "https://australiancontractor.com.au/join";

export const NEXT_STEPS = {
    heading: "Your next steps",
    steps: [
        { title: "Join PayMe", text: "Takes about 5 minutes online.", who: "You", button: "Join PayMe" },
        { title: "Get your new contract", text: "Your recruiter sends a contract that allows outsourced payroll.", who: "Your recruiter and PayMe" },
        { title: "Complete payroll forms", text: "Tax, super and bank details.", who: "You" },
        { title: "Submit your timesheet and get paid", text: "Send your hours and we pay you.", who: "You and PayMe" },
    ],
};
